// extracted by mini-css-extract-plugin
export var chevronIcon = "_as-2";
export var teamName = "_as-1";
export var teamSwitcherButton = "_as-0";